import ExpandableSection from "../component/_expandableSection";
document.addEventListener('DOMContentLoaded', function() {
    // Initialize the TOC dropdown
    new ExpandableSection('.js-toc-dropdown', '.js-toc-dropdown-header', '.js-toc-dropdown-content', '.js-toc-dropdown-chevron', false, true, false, true, false);


    const header = document.querySelector(".js-post-hero-title");
    if (header) {
        let text = header.innerHTML;
        text = text.replace(/&nbsp;/g, ' ');
        text = text.replace(
            /\s([aiouwzAIUOWZ])\s/g,
            (match, spojnik) => ` ${spojnik}&nbsp;`
        );

        text = text.replace(/(\S)-(\S)/g, '$1&#8209;$2');

        header.innerHTML = text;
    }

});
